import { css } from "@emotion/react";

import { Badge, BadgeColors, colors } from "@dotnet/telematics-design-system";

import NameWithTooltip from "components/TableDetails/components/NameWithTooltip";

import { CompanyProps } from "../types/interfaces";

const Company = ({ data, index, isActive }: CompanyProps) => {
    const { gray200, white } = colors;

    const marginLeft = 28 * index;

    const getNumber = () => `${index < 10 ? 0 : ""}${index + 1}`;

    return (
        <li
            css={css({
                display: "flex",
                maxWidth: "286px",
                marginLeft: `${marginLeft}px`
            })}
        >
            <Badge
                color={isActive ? BadgeColors.info : BadgeColors.light}
                inverted={isActive}
                IconLeft={() => getNumber()}
            >
                <span
                    css={css({
                        position: "relative",
                        paddingLeft: "4px",
                        maxWidth: "246px"
                    })}
                >
                    <span
                        css={css({
                            position: "absolute",
                            top: "-4px",
                            bottom: "-4px",
                            left: "0",
                            width: "1px",
                            background: isActive ? white : gray200,
                            opacity: isActive ? "0.4" : "1"
                        })}
                    />

                    <NameWithTooltip
                        name={data.name}
                        lineH={16}
                        fontSize={12}
                    />
                </span>
            </Badge>
        </li>
    );
};

export default Company;
